import { Overlay } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { AutoCompleteService } from 'src/app/modules/route-planner/services/auto-complete/auto-complete.service';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { eFavoriteType } from 'src/app/modules/route-planner/enums/favorite/favorite-type.enum';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export abstract class BaseAutoCompleteComponent<T> extends CardDesignComponent {
  protected FEED_LAST_SEARCHES_AMOUNT: number = 5;
  protected readonly debounceTime: number =
    AutoCompleteService.AUTO_COMPLETE_DEBOUNCE_TIME;
  protected readonly autoCompleteMinChar: number =
    AutoCompleteService.AUTO_COMPLETE_MIN_CHAR;

  formControl: FormControl<string> = new FormControl<string>(null);
  results$: Observable<SelectOption<T>[]>;
  emptyResults$ = new BehaviorSubject<boolean>(false);

  constructor(
    protected readonly favoritesService: FavoritesService,

    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay?: Overlay
  ) {
    super(routePlanningService, resizeService, overlay);
  }

  protected abstract insertChosenValueToStorage(value: T);

  chooseValue(address: T, insertToLastSearches: boolean = true) {
    if (!!insertToLastSearches) {
      this.insertChosenValueToStorage(address);
    }

    this.closeCard(address);
  }

  clearValue() {
    this.results$ = of([]);
    this.formControl.setValue(null);
  }

}
